/**
 * 马来语
 */
export default {
  name: 'ms',
  el: {
    colorpicker: { confirm: 'Sahkan', clear: 'Kosongkan' },
    datepicker: {
      now: 'Sekarang',
      today: 'Hari Ini',
      cancel: 'Batal',
      clear: 'Kosongkan',
      confirm: 'Sahkan',
      selectDate: 'Pilih Tarikh',
      selectTime: 'Pilih Masa',
      startDate: 'Tarikh Mula',
      startTime: 'Masa Mula',
      endDate: 'Tarikh Tamat',
      endTime: 'Masa Tamat',
      prevYear: 'Tahun Lepas',
      nextYear: 'Tahun Depan',
      prevMonth: 'Bulan Lepas',
      nextMonth: 'Bulan Depan',
      year: 'tahun',
      month1: 'Januari',
      month2: 'Februari',
      month3: 'Mac',
      month4: 'April',
      month5: 'Mei',
      month6: 'Jun',
      month7: 'Julai',
      month8: 'Ogos',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Disember',
      weeks: { sun: 'Aha', mon: 'Isn', tue: 'Sel', wed: 'Rab', thu: 'Kha', fri: 'Jum', sat: 'Sab' },
      months: {
        jan: 'Januari',
        feb: 'Februari',
        mar: 'Mac',
        apr: 'April',
        may: 'Mei',
        jun: 'Jun',
        jul: 'Julai',
        aug: 'Ogos',
        sep: 'September',
        oct: 'Oktober',
        nov: 'November',
        dec: 'Disember'
      }
    },
    select: {
      loading: 'Memuatkan',
      noMatch: 'Tiada padanan data',
      noData: 'Tiada data',
      placeholder: 'Sila pilih'
    },
    cascader: {
      noMatch: 'Tiada padanan data',
      loading: 'Memuatkan',
      placeholder: 'Sila pilih',
      noData: 'Tiada data'
    },
    paginasi: {
      goto: 'Pergi ke',
      pagesize: 'Baris/halaman',
      total: 'Jumlah semua {total}',
      pageClassifier: 'halaman',
      page: 'halaman',
      prev: 'Halaman sebelumnya',
      next: 'Halaman berikutnya',
      currentPage: 'Halaman {pager}',
      prevPages: 'Halaman sebelumnya {pager}',
      nextPages: 'Halaman berikutnya {pager}',
      deprecationWarning:
        'Anda menggunakan beberapa penggunaan yang sudah usang, silakan merujuk ke dokumen resmi el-pagination'
    },
    kotakpesan: {
      title: 'Pemberitahuan',
      confirm: 'OK',
      cancel: 'Batal',
      error: 'Input tidak valid!'
    },
    muatnaik: {
      deleteTip: 'Tekan tombol delete untuk hapus',
      delete: 'Hapus',
      preview: 'Lihat gambar',
      continue: 'Terus memuat naik'
    },
    jadual: {
      emptyText: 'Tiada data',
      confirmFilter: 'Saring',
      resetFilter: 'Set semula',
      clearFilter: 'Kosongkan',
      sumText: 'Jumlah'
    },
    pokokpohon: { emptyText: 'Tiada data' },
    pemindahan: {
      noMatch: 'Tiada padanan data',
      noData: 'Tiada data',
      titles: ['Senarai 1', 'Senarai 2'],
      filterPlaceholder: 'Masukkan kata kunci',
      noCheckedFormat: 'Jumlah {total} item',
      hasCheckedFormat: '{checked}/{total} item terpilih'
    },
    imej: { error: 'Gagal memuatkan' },
    headerhalaman: { title: 'Kembali' },
    poppengesahan: { confirmButtonText: 'OK', cancelButtonText: 'Batal' }
  }
}
